import { motion } from "framer-motion";
import { encajeDeLaCara } from "@/lib/encajeDeLasCaras.mjs";

/**
 * El retrato de un mentor: su cara anime, en un disco, a cualquier tamaño.
 *
 * Gabri, 3 de noviembre de 2026: *«quitamos los chibis de las miniaturas de chat y ponemos los
 * mentores versión anime en toda la plataforma»*. Son las caras que eligió el 29 de octubre para
 * la portada (`public/mentores/caras/`), y ahora son las únicas: de dónde salen, en su `PROCEDENCIA.md`.
 *
 * UN SOLO RECORTE PARA TODOS LOS TAMAÑOS. Antes había dos, busto y cara, porque un busto a 32 px era
 * una mancha. Estas ya son caras, y a 32 px se distinguen los seis.
 *
 * Y EL GESTO. Una imagen no cambia de cara mientras el mentor piensa, así que lo dice el anillo,
 * que late mientras `mood` es "thinking". El acierto y el fallo del repaso van escritos al lado.
 */

export default function RetratoDeMentor({
  character, size, dark, label, mood = "idle", animate = true, tinta, rojo,
}) {
  const borde = dark ? rojo : tinta;
  const pensando = mood === "thinking" && animate;

  return (
    <div style={{ position: "relative", width: size, height: size, flexShrink: 0 }}>
      <div
        style={{
          width: size, height: size, borderRadius: "50%", overflow: "hidden",
          // BLANCO Y NO CREMA: las caras traen su fondo blanco, y sobre crema se le vería el borde.
          background: "#fff", border: `2.5px solid ${borde}`, boxSizing: "border-box",
        }}
        data-testid={`alpha-avatar-${character}-retrato`}
      >
        <img
          src={`/mentores/caras/${character}.webp`}
          alt={label}
          width={size}
          height={size}
          loading="lazy"
          decoding="async"
          style={{
            width: "100%", height: "100%", objectFit: "cover", display: "block",
            transform: encajeDeLaCara(character),
          }}
        />
      </div>

      {/* El latido de «estoy pensando». Va fuera del círculo recortado para que no lo corte
          el `overflow: hidden`, y no captura el ratón. */}
      {pensando && (
        <motion.span
          aria-hidden="true"
          initial={{ opacity: 0.15, scale: 1 }}
          animate={{ opacity: [0.15, 0.75, 0.15], scale: [1, 1.12, 1] }}
          transition={{ duration: 1.4, repeat: Infinity, ease: "easeInOut" }}
          style={{
            position: "absolute", inset: -3, borderRadius: "50%",
            border: `2px solid ${rojo}`, pointerEvents: "none",
          }}
        />
      )}
    </div>
  );
}
